// Redux/Slices/editBookingSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ReserEditBooking } from '../../Services/Service';

export const updateBooking = createAsyncThunk(
  'editBooking/updateBooking',
  async (payload, { rejectWithValue }) => {
    try {
      const result = await ReserEditBooking(payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ReserEditBookingSlice = createSlice({
  name: 'editBooking',
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetEditBooking: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateBooking.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetEditBooking } = ReserEditBookingSlice.actions;
export default ReserEditBookingSlice.reducer;